import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import useLoadingProgress from "@sprout/hooks/dist/useLoadingProgress";
import { ItemType, PostPageViewsPost_ItemOrDirectChildUpdatedDocument, usePostPageViewsPostQuery } from "sprout-graphql";
import { Glitch, NotFound } from "@sprout/views";
import { useParams } from "react-router-dom";
import TrackJumpHistory from "@sprout/client-components/dist/TrackJumpHistory";
import FeatureFlaggedSubscription from "@sprout/client-lib/dist/FeatureFlaggedSubscription";
import Head from "@sprout/client-layout/dist/Head";
import { getReadableDescription, getItemUrl } from "sprout-lib";
import { Page } from "@sprout/client-layout";
import { Text } from "sprout-ui-primitives";
import PostPagePage from "../PostPagePage";
import PostPageViewsPostMain from "./PostPageViewsPostMain";
import PostPageViewsPostToolbar from "./PostPageViewsPostToolbar";
const PostPageViewsPost = ()=>{
    const { postId  } = useParams();
    const { loading , data , error  } = usePostPageViewsPostQuery({
        variables: {
            postId: Number(postId)
        },
        fetchPolicy: "cache-and-network",
        nextFetchPolicy: "cache-first"
    });
    const post = data === null || data === void 0 ? void 0 : data.post;
    const isInitialLoad = loading && !post;
    useLoadingProgress(isInitialLoad);
    if (loading && !post) return null;
    if (error) return /*#__PURE__*/ _jsx(Glitch, {
        error: error
    });
    if (!post || post.type !== ItemType.Post || post.isDraft) return /*#__PURE__*/ _jsx(NotFound, {});
    if (!post.rootTopicOrSelf) return /*#__PURE__*/ _jsx(Page, {
        variant: "shadow",
        fullHeight: false,
        maxWidth: 600,
        children: /*#__PURE__*/ _jsxs(Text, {
            textAlign: "center",
            children: [
                /*#__PURE__*/ _jsx(Text, {
                    as: "h1",
                    fontSize: 5,
                    mt: "8px",
                    mb: "24px",
                    children: "Sorry, this page is temporarily unavailable."
                }),
                /*#__PURE__*/ _jsx(Text, {
                    as: "p",
                    mb: "48px",
                    children: "We are currently fixing this, and will be back as soon as possible!"
                })
            ]
        })
    });
    const { description , rootTopicOrSelf , parentTopic  } = post;
    const goBackURL = getItemUrl(parentTopic, rootTopicOrSelf === null || rootTopicOrSelf === void 0 ? void 0 : rootTopicOrSelf.owner);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(TrackJumpHistory, {
                type: ItemType.Post,
                data: {
                    itemId: post.id
                }
            }),
            /*#__PURE__*/ _jsx(FeatureFlaggedSubscription, {
                subscription: PostPageViewsPost_ItemOrDirectChildUpdatedDocument,
                variables: {
                    postId: post.id
                }
            }),
            /*#__PURE__*/ _jsx(Head, {
                title: description ? `${getReadableDescription(description)} | Sprout` : "Sprout"
            }),
            /*#__PURE__*/ _jsx(PostPagePage, {
                goBackURL: goBackURL,
                item: post,
                main: /*#__PURE__*/ _jsx(PostPageViewsPostMain, {
                    post: post
                }),
                toolbar: /*#__PURE__*/ _jsx(PostPageViewsPostToolbar, {
                    post: post
                })
            })
        ]
    });
};
export default PostPageViewsPost;
